import { hasValue, isNullOrUndefined, toggleCssClass } from "../../../general/js/general-helpers";
import HtmlHelper from "../../../foundation/html-helper";
import { modalConstants } from "./modal-constants";

export const getWrapperModalElement = (element = null) => {
    if(isNullOrUndefined(element) || !HtmlHelper.isHtmlElement(element)){
        return null;
    }

    return HtmlHelper.getParent(element, `[${modalConstants.dataModal}]`);
}

export const toggleBemClassForWrapperModal = (element = null, bemList = [], addClass = false) => {
    if(!hasValue(bemList) || isNullOrUndefined(element)){
        return;
    }

    const wrapperModal = getWrapperModalElement(element);
    
    if(isNullOrUndefined(wrapperModal)){
        return;
    }

    bemList.forEach(bemClass => {
        toggleCssClass(wrapperModal, bemClass, addClass);
    });
}